import axios from 'axios';
import { debug } from 'debug';
import { getReasonPhrase, StatusCodes } from 'http-status-codes';
import { HTTPRequestError } from '../../models/http';
import { PREDEF_ANSWERS_ROUTE } from '../configs/predef-answers-api';
import {
	PredefinedAnswerAction,
	PredefinedAnswersActionResponse,
	PredefinedAnswersUpdateRequest,
} from '../models/payload-parts';

export const updateAnswer = async (
	payload: PredefinedAnswersUpdateRequest,
): Promise<PredefinedAnswerAction> => {
	const response = await axios.patch<PredefinedAnswersActionResponse>(
		PREDEF_ANSWERS_ROUTE.UPDATE,
		payload,
	);

	if (response.status !== StatusCodes.OK) {
		debug(`Error: ${response.status}`);
		throw new HTTPRequestError(getReasonPhrase(response.status));
	}

	return response.data.responsePayload;
};
